import { Card } from '@talentmesh/ui/components/card';
import RecruitmentListItemBody from './RecruitmentListItemBody';
import RecruitmentListItemFooter from './RecruitmentListItemFooter';
import { RecruitmentListItemHeader } from './RecruitmentListItemHeader';
import { RecruitmentOverview } from '@/Models/RecruitmentOverview';

interface RecruitmentListItemProps {
    recruitment: RecruitmentOverview;
}
function RecruitmentListItem({ recruitment }: RecruitmentListItemProps) {
    return (
        <Card className="w-full border p-5 drop-shadow" data-cy="recruitmentCard">
            <div className="flex flex-col gap-3">
                <RecruitmentListItemHeader recruitment={recruitment} />
                <RecruitmentListItemBody recruitment={recruitment} />
                <RecruitmentListItemFooter recruitment={recruitment} />
            </div>
        </Card>
    );
}

export default RecruitmentListItem;
